import AuthApiClient from "api/AuthApiClient";
import { Loader } from "uikit/components";
import React from "react";

export const SsoLoginRedirect = () => {
    window.location.href = AuthApiClient.buildChallengeUrl(window.location.pathname);
    return <Loader position="margin-auto" />;
};
